import { useState, useEffect } from 'react';
import { isBrowser } from '../utils/isBrowser';

interface LatLngProps {
  lat: string;
  long: string;
}

interface ErrorProps {
  code: number;
  message: string;
}
export const useGeoLocation = () => {
  const [location, setLocation] = useState<LatLngProps>();
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<ErrorProps>();

  const onSuccess = ({ coords }) => {
    setError(undefined);
    setLocation({
      lat: coords.latitude,
      long: coords.longitude,
    });
    setLoaded(true);
  };

  const onError = (errorMessage) => {
    setLocation(undefined);
    setLoaded(true);
    setError({
      code: errorMessage.code,
      message: errorMessage.message,
    });
  };

  const clearGeoLocation = () => {
    setLocation(undefined);
    setLoaded(false);
    setError(undefined);
  };

  useEffect(() => {
    if (!isBrowser || !('geolocation' in navigator)) {
      onError({
        code: 0,
        message: 'Geolocation not supported',
      });
    }
  }, []);
  const requestGeoLocation = () => {
    if (isBrowser) {
      window.navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }
  };

  return { location, loaded, error, requestGeoLocation, clearGeoLocation };
};
